// 텍스트 클립보드 복사 — 안전하지 않은 컨텍스트(http로 접속한 도메인)까지 커버.
//
// navigator.clipboard는 secure context(https 또는 localhost)에서만 존재한다.
// 사내 서버를 http로 열어 쓰는 경우 undefined라, 예전 코드처럼
// `navigator.clipboard?.writeText(...)` 로 두면 아무 일도 안 하고 조용히 끝난다
// ("복사 버튼을 눌러도 안 붙여넣어짐"의 흔한 원인). 그래서 구식 execCommand로 폴백한다.
//
// 반환값이 false면 호출 측이 "직접 복사하세요" 안내를 띄워야 한다.
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // 권한 거부/비활성 탭 등 — 아래 폴백으로 계속.
    }
  }

  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    // 화면 밖에 두되 focus 가능해야 execCommand가 동작한다(display:none은 실패).
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
